import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('blob', '/blobs')
const reducer = generator.generate()

export default reducer
